export default __webpack_public_path__ + "static/media/saving-bank-logo.03b3b2ad.svg";